import { render, staticRenderFns } from "./WorkGroupDialog.vue?vue&type=template&id=54374ddf"
import script from "./WorkGroupDialog.vue?vue&type=script&lang=ts"
export * from "./WorkGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports